import React from 'react';
import { Grid } from '@mui/material';
import Routes from '../../../routes';
import {
    Select,
    WeightInput,
} from '../../Common';
import { oil_type_options, unknownCylinder, getContainerSpacing } from '../utils';

const NewSystemDetails = ({
    formState,
    setGlobalState,
    dropdownOptions,
    setDropdownOptions,
    requiredFieldsMissing,
    isRetrofit,
}) => {
    const refetchInstallCylinders = async (newMaterialTypeID) => {
        const { assetId = '', primaryTechnicianId = '' } = formState;
        // need to refetch install cylinder based on the newMaterialTypeID
        const installURL = Routes.Asset.FetchInstallCylindersForRetrofit(assetId, primaryTechnicianId, newMaterialTypeID);
        const fetchInstallCylinders = async () => {
            const options = {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
            };
            fetch(installURL, options)
            .then(async (response) => {
                const cylinders = await Promise.resolve(response.json());
                console.log('install cylinders based on newMaterialTypeID', cylinders);
                setDropdownOptions((prev) => ({
                    ...prev,
                    installCylinders: [...unknownCylinder, ...cylinders]
                }));
            })
            .catch(error => console.log('Error fetching install Cylinder list', error));
        };
        await fetchInstallCylinders();
    };

    return (
        <Grid container spacing={getContainerSpacing()}>
            <Grid item xs={12} md={6}>
                <Select
                    required
                    label="New Material Type"
                    value={formState.newMaterialTypeId}
                    onChange={e => {
                        setGlobalState("newMaterialTypeId", e.target.value);
                        if (isRetrofit) {
                            refetchInstallCylinders(e.target.value);
                        }
                    }}
                    options={dropdownOptions.materialTypes}
                    error={requiredFieldsMissing.newMaterialTypeId}
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <Select
                    required
                    label="New Oil Type"
                    value={formState.newOilType}
                    onChange={e => setGlobalState("newOilType", e.target.value)}
                    options={oil_type_options}
                    error={requiredFieldsMissing.newOilType}
                />
            </Grid>
            <WeightInput
                showConversionArrows
                header="New Gas Charge Capacity"
                variant="standard"
                columnSpan={5}
                value={formState.newGasChargeCapacityLbs}
                onChange={data => setGlobalState("newGasChargeCapacityLbs", data)}
                lbsError={requiredFieldsMissing.newGasChargeCapacityLbs}
            />
        </Grid>
    );
};

export default NewSystemDetails;
